
export default require('./env/' + process.env.NODE_ENV).default